import { motion } from "framer-motion";
import MahindraLogo from "@/components/MahindraLogo";

const CAMPUS_IMAGE = `${process.env.PUBLIC_URL || ""}/login/campus-entrance.png`;

/**
 * Left brand pane — same layout as the Registration Portal landing.
 * Uses the campus entrance photo under a Mahindra red wash.
 */
export default function LoginBrandPanel() {
  return (
    <aside
      className="relative hidden min-h-screen flex-col justify-between overflow-hidden bg-[#B60F2A] lg:flex"
      data-testid="login-brand-panel"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.4) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.25) 0%, transparent 45%)",
        }}
      />
      <div className="absolute inset-0">
        <img
          src={CAMPUS_IMAGE}
          alt=""
          aria-hidden
          className="h-full w-full object-cover opacity-35 mix-blend-luminosity"
        />
      </div>

      <div className="relative flex items-center gap-3 p-10">
        <div className="rounded-xl bg-white p-2">
          <MahindraLogo size="compact" transparent className="max-w-[180px]" />
        </div>
        <div className="text-xs font-semibold uppercase tracking-[0.15em] text-white/90">
          MU One · Campus Portal
        </div>
      </div>

      <div className="relative p-10 md:p-14">
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-bold leading-tight tracking-tight text-white md:text-5xl"
        >
          One portal for campus life beyond class.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-4 max-w-md text-lg text-white/80"
        >
          Sign in with your registered mobile to access HR, hostels, and campus
          operations.
        </motion.p>
      </div>

      <div className="relative p-10 text-xs text-white/60">
        &ldquo;Global Thinkers. Engaged Leaders.&rdquo;
      </div>
    </aside>
  );
}
